module.exports = __webpack_public_path__ + "img/nz.ef64d30b.jpg";